






























import { Component, Ref, Vue, Emit, Prop, Watch } from 'vue-property-decorator';
import { resetPassword } from '@/utils/api';
@Component
export default class DictListView extends Vue {
  @Prop(Object) val!: object;
  @Watch('val', { deep: true })
  handleWatch(newval, oldval) {
    if (newval) {
      this.ruleForm = newval.supplierAdminUser;
      this.code = newval.code;
      this.id = newval.id;
    }
  }
  dialogVisible: Boolean = false;
  ruleForm: object = {};
  code: string = '';
  id: number = 0;
  submit() {
    let obj = {
      id: this.id,
    };

       resetPassword(obj).then(res =>{
           console.log(res)
       })
  }
  handleClose(done) {
    this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => {});
  }
}
